var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "article",
    { class: { rsp2CurrentNewsItem: true, rsp2Hatching: _vm.hatching } },
    [
      _c("a", { attrs: { href: _vm.url } }, [
        _c("div", { staticClass: "rsp2IconContainer" }, [
          _c("div", {
            staticClass: "rsp2Icon",
            domProps: { innerHTML: _vm._s(_vm.icon) }
          })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "rsp2Content" }, [
          _c("h3", [
            _c("span", { staticClass: "rsp2Category" }, [
              _vm._v(_vm._s(_vm.category))
            ]),
            _vm._v(" "),
            _c(
              "span",
              { staticClass: "rsp2Title", attrs: { title: _vm.title } },
              [_vm._v(_vm._s(_vm.title))]
            )
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "rsp2Metadata" }, [
            _vm._v(
              "Von " +
                _vm._s(_vm._f("fullName")(_vm.author)) +
                _vm._s(_vm._f("prepend")(_vm._f("formatDate")(_vm.date), " am"))
            )
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }